import type { SVGProps } from "react";
// generated from Play.svg — do not edit manually
// prettier-ignore
export default function Play(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 20 12 L 6 4 V 20 L 20 12 Z" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
